import { render, staticRenderFns } from "./mallPicture1.vue?vue&type=template&id=2d944215&scoped=true"
import script from "./mallPicture1.vue?vue&type=script&lang=js"
export * from "./mallPicture1.vue?vue&type=script&lang=js"
import style0 from "./mallPicture1.vue?vue&type=style&index=0&id=2d944215&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d944215",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d944215')) {
      api.createRecord('2d944215', component.options)
    } else {
      api.reload('2d944215', component.options)
    }
    module.hot.accept("./mallPicture1.vue?vue&type=template&id=2d944215&scoped=true", function () {
      api.rerender('2d944215', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/mallPicture1.vue"
export default component.exports